import React from "react";
import { Slider } from "antd";
import { ReactComponent as PlayIcon } from "@/assets/icons/play.svg";
import { ReactComponent as PauseIcon } from "@/assets/icons/pause.svg";
import { ReactComponent as MuteIcon } from "@/assets/icons/volume-mute.svg";
import { ReactComponent as LoundIcon } from "@/assets/icons/volume-lound.svg";
import "@/assets/audioCutSpeedVolume.less";

const AudioWorkVolumeRender = ({ playing, volumeValue, volume, tooglePlay, handleVolumeChange }) => {
  return (
    <div className="work-speed">
      {playing ? (
        <PauseIcon style={{ width: 32, height: 32, marginBottom: 18, cursor: "pointer" }} onClick={tooglePlay} />
      ) : (
        <PlayIcon style={{ width: 32, height: 32, marginBottom: 18, cursor: "pointer" }} onClick={tooglePlay} />
      )}
      <div className={`speed-opr ${volume < 100 ? "left" : "right"}`}>
        <MuteIcon />
        <Slider value={volumeValue} range min={0} max={300} step={1} marks={{ 100: "" }} onChange={handleVolumeChange} />
        <LoundIcon />
        <span style={{ marginLeft: 6 }}>{volume}%</span>
      </div>
    </div>
  );
};

export default AudioWorkVolumeRender;
